import { listSelectableSkills } from '#pplx/frontend/apps/ask/skills/hooks/internal/listSelectableSkills.js';
import { getSelectableSkillsQueryKey } from '#pplx/frontend/apps/ask/skills/skillsKeys.js';
import { useInfiniteQuery } from '#pplx/frontend/react-query/useInfiniteQuery.js';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
const DEFAULT_SELECTABLE_SKILLS_LIMIT = 100;
export const useSelectableSkills = ({ app, enabled = true, limit = DEFAULT_SELECTABLE_SKILLS_LIMIT, collectionUuid, }) => {
    const query = useInfiniteQuery({
        queryKey: getSelectableSkillsQueryKey({ app, limit, collectionUuid }),
        queryFn: async ({ pageParam }) => {
            return listSelectableSkills({ app, limit, cursor: pageParam ?? undefined, collection_uuid: collectionUuid }, 'use-selectable-skills-hook');
        },
        getNextPageParam: (lastPage) => lastPage?.next_cursor ?? undefined,
        initialPageParam: null,
        enabled,
        placeholderData: keepPreviousData,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
    const skills = useMemo(() => {
        return query.data?.pages.flatMap((page) => page?.skills ?? []) ?? [];
    }, [query.data]);
    return useMemo(() => ({
        skills,
        isLoading: query.isLoading,
        hasNextPage: query.hasNextPage ?? false,
        fetchNextPage: query.fetchNextPage,
        error: query.error,
    }), [skills, query.isLoading, query.hasNextPage, query.fetchNextPage, query.error]);
};
//# sourceMappingURL=useSelectableSkills.js.map